import React from 'react';

export const changeEnter = (text: any) => {
  return text?.split('')?.map((data: any) => {
    return data === '\n' ? <br /> : data;
  });
};

export const changeEnterHTML = (text: any) => {
  return text
    ?.replace(/\{\{\$/g, '{{\\$')
    ?.split('')
    ?.map((data: any) => {
      return data === '\n' ? '<br />' : data;
    })
    .join('');
};
